import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MonthInPractice } from './components/MonthInPractice';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { preTestimonials, postTestimonials } from './data/testimonials';
import { useViewContent } from './hooks/useViewContent';
export function App() {
  useViewContent();
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-sage-tint selection:text-ink" data-id="element-0" data-mp="3mkrd9k285fcs">
      <MetaPixel data-id="element-1" data-mp="3rdas0kcnegj6" />
      <main data-id="element-2" data-mp="3rcsw5otwe4bs">
        <Hero data-id="element-3" data-mp="3rd17vdeab3le" />
        <SocialProofBar data-id="element-4" data-mp="3relw6la09qat" />
        <Testimonials testimonials={preTestimonials} background="ivory" data-id="element-5" data-mp="6hr7hlrojf6" />
        <MonthInPractice data-id="element-6" data-mp="7sxbo2oq39g" />
        <PainGrid data-id="element-7" data-mp="2zllcouynw8jk" />
        <BigIdea data-id="element-8" data-mp="2zm4xqkjlzd1t" />
        <ProductReveal data-id="element-9" data-mp="2zmo5x9jgin2n" />
        <Volumes data-id="element-10" data-mp="2zng0ch1bierc" />
        <Bonuses data-id="element-11" data-mp="33mf2jtvnzxf3" />
        <Urgency data-id="element-12" data-mp="33lwywc6oagx5" />
        <Pricing data-id="element-13" data-mp="33ngee0ki8nxv" />
        <Transformation data-id="element-14" data-mp="33myn7icp8zwt" />
        <Testimonials testimonials={postTestimonials} title="More couples, fewer 2 a.m. spirals" background="ivory" data-id="element-15" data-mp="38lromcepp0gm" />
        <Guarantee data-id="element-16" data-mp="3dlnt0crbmtwp" />
        <Faq data-id="element-17" data-mp="3dm5vvs8ho6dl" />
        <CostOfInaction data-id="element-18" data-mp="3dii5h1ycc033" />
        <Close data-id="element-19" data-mp="nw2a60hx7gog" />
      </main>
      <Footer data-id="element-20" data-mp="nur6s1se0axv" />
    </div>;
}